export default "__VITE_ASSET__D$aNPb1q__"